import { render, staticRenderFns } from "./HomePayment.vue?vue&type=template&id=2dba32b8&scoped=true&"
var script = {}
import style0 from "./HomePayment.vue?vue&type=style&index=0&id=2dba32b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dba32b8",
  null
  
)

export default component.exports